const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8080';

export const API = {
  baseUrl: API_BASE_URL,
  kakaoAuthorize: `${API_BASE_URL}/oauth/kakao/authorize`,
  kakaoLogout: `${API_BASE_URL}/oauth/kakao/logout`,
} as const;
